import React from 'react';
import styled from 'styled-components';

import InfiniteScroll from '@/components/common/InfiniteScroll';
import Doctor from '@/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Doctor/Doctor';
import DoctorResultEmpty from '@/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Doctor/DoctorResultEmpty';
import { SearchDoctorViewModel } from '@/hooks/search/doctor/useSearchDoctorViewModel';

import DoctorSkeleton from './DoctorSkeleton';

interface Props {
  viewModel: SearchDoctorViewModel;
}

const DoctorSearchResult = ({ viewModel }: Props) => {
  if (viewModel.isLoading) {
    return <DoctorSkeleton />;
  }

  if (!viewModel.doctors.length) {
    return (
      <DoctorResultEmpty
        handleClickRequestButton={viewModel.moveToCategoryListScreen}
      />
    );
  }

  return (
    <Wrapper>
      <InfiniteScroll
        isLoading={viewModel.isLoading}
        hasNextPage={viewModel.hasNextPage}
        fetchNextPage={viewModel.fetchNextPage}
      >
        {viewModel.doctors?.map((doctor) => (
          <Doctor
            key={doctor.id}
            doctor={doctor}
            onClick={() => viewModel.onClickDoctor(doctor.publicId)}
          />
        ))}
      </InfiniteScroll>
    </Wrapper>
  );
};

export default DoctorSearchResult;

const Wrapper = styled.ul`
  > section > div > div:not(:last-child) {
    border-bottom-width: 1px;
    border-bottom-color: ${({ theme }) => theme.color.gray40};
    border-bottom-style: solid;
  }
`;
